import { gql, useQuery } from "@apollo/client";

/**
 * GraphQL query for fetching all version information
 */
export const GET_VERSIONS = gql`
  query GetVersions {
    versions {
      oc
      jdapi
      munkaugy
      jelenlet
    }
  }
`;

/**
 * Version information for all system components
 */
export interface VersionInfo {
  /** OrgwareConnect frontend/backend version */
  oc: string;
  /** JD-Gateway API version */
  jdapi: string;
  /** Munkaugy (HR) module version */
  munkaugy: string;
  /** Jelenlet (Attendance) module version */
  jelenlet: string;
}

/**
 * Hook to fetch runtime version information for all system components.
 *
 * Used by the about dialog to display accurate runtime versions
 * instead of build-time static values.
 *
 * @returns Apollo useQuery result with VersionInfo data
 *
 * @example
 * const { data, loading, error } = useVersions();
 * const versions = data?.versions;
 */
export const useVersions = () => {
  return useQuery<{ versions: VersionInfo }>(GET_VERSIONS, {
    fetchPolicy: "cache-first",
    // Refresh every 5 minutes
    pollInterval: 300000,
  });
};

export default useVersions;
